import { CodeIcon, CoinFilledIcon, ClockFilledIcon, CalendarEventFilledIcon } from '@icons'
import { m, AnimationProps, LazyMotion, domAnimation } from 'framer-motion'

import {
  CompanyArcade,
  CompanyFastby,
  CompanyHoplin,
  SkillAndroid,
  SkillJava,
  SkillReact,
  SkillReactNative,
  SkillRuby,
} from '../../../../../assets/icons'

import styles from './index.module.scss'

type CardContentType = {
  animate: AnimationProps[]
}

const CardContent = ({ animate }: CardContentType) => {
  return (
    <LazyMotion features={domAnimation} strict>
      <m.div className={styles['opportunity-card']} {...animate[0]}>
        <p className={styles['company']}>
          <CompanyHoplin className={styles['company-icon']} />
          Hoplin
        </p>
        <p className={styles['position']}>Fullstack Developer</p>
        <div className={styles['skills-wrapper']}>
          <div className={styles['picture-container']}>
            <SkillJava className={styles['picture']} key="java-sm" />
            <SkillAndroid className={styles['picture']} key="android-sm" />
          </div>
          <p className={styles['names']}>Java, Android</p>
        </div>
        <ul className={styles['details']}>
          <li className={styles['details-item']}>
            <CodeIcon className={styles['details-icon']} />5 years of experience
          </li>
          <li className={styles['details-item']}>
            <CoinFilledIcon className={styles['details-icon']} />
            $5,000-7,000 USD/month
          </li>
          <li className={styles['details-item']}>
            <ClockFilledIcon className={styles['details-icon']} />
            30 hours/week
          </li>
          <li className={styles['details-item']}>
            <CalendarEventFilledIcon className={styles['details-icon']} />
            12 month contract
          </li>
        </ul>
      </m.div>
      <m.div className={styles['opportunity-card']} {...animate[1]}>
        <p className={styles['company']}>
          <CompanyFastby className={styles['company-icon']} />
          Fastby
        </p>
        <p className={styles['position']}>Backend Engineer</p>
        <div className={styles['skills-wrapper']}>
          <div className={styles['picture-container']}>
            <SkillRuby className={styles['picture']} key="ruby-sm" />
          </div>
          <p className={styles['names']}>Ruby on rails</p>
        </div>
        <ul className={styles['details']}>
          <li className={styles['details-item']}>
            <CodeIcon className={styles['details-icon']} />5 years of experience
          </li>
          <li className={styles['details-item']}>
            <CoinFilledIcon className={styles['details-icon']} />
            $5,000-7,000 USD/month
          </li>
          <li className={styles['details-item']}>
            <ClockFilledIcon className={styles['details-icon']} />
            30 hours/week
          </li>
          <li className={styles['details-item']}>
            <CalendarEventFilledIcon className={styles['details-icon']} />
            12 month contract
          </li>
        </ul>
      </m.div>
      <m.div className={styles['opportunity-card']} {...animate[2]}>
        <p className={styles['company']}>
          <CompanyArcade className={styles['company-icon']} />
          Arcade
        </p>
        <p className={styles['position']}>Frontend Developer</p>
        <div className={styles['skills-wrapper']}>
          <div className={styles['picture-container']}>
            <SkillReact className={styles['picture']} key="react-sm" />
            <SkillReactNative className={styles['picture']} key="rn-sm" />
          </div>
          <p className={styles['names']}>React, React Native</p>
        </div>
        <ul className={styles['details']}>
          <li className={styles['details-item']}>
            <CodeIcon className={styles['details-icon']} />5 years of experience
          </li>
          <li className={styles['details-item']}>
            <CoinFilledIcon className={styles['details-icon']} />
            $5,000-7,000 USD/month
          </li>
          <li className={styles['details-item']}>
            <ClockFilledIcon className={styles['details-icon']} />
            30 hours/week
          </li>
          <li className={styles['details-item']}>
            <CalendarEventFilledIcon className={styles['details-icon']} />
            12 month contract
          </li>
        </ul>
      </m.div>
    </LazyMotion>
  )
}
export default CardContent
